import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import c from "../../constant";
import TokenGroup from "@cloudscape-design/components/token-group";
import Modal from "@cloudscape-design/components/modal";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Button from "@cloudscape-design/components/button";
import {
    Flex,
    Text,
    Avatar,
    WrapItem
} from '@chakra-ui/react';
import getDepartmentLabel from "../../utils/getDepartmentLabel"
import SelectDepartmentModal from "./SelectDepartmentModal"
import "./style.css"
import useStore from "../../store"
import { faMinusSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { gql, useMutation } from '@apollo/client';

const REMOVE_DEPARTMENT = gql`
    mutation assign($id: String!, $department: String!, $removeUsers: JSON!
        ) {
        removeCompanySubmissionProposalDepartmentAndUser(id: $id, department: $department, removeUsers: $removeUsers)
    }
`;


const leftLabelWidth = '165px';
export default function AssignToDepartment({ data, id, callBack, assignedUserData, officeData }) {
    const { t } = useTranslation();
    const { currentUser } = useStore((state) => state.currentUser);
    const { currentLang } = useStore((state) => state.currentLang);
    const canAssign = currentUser?.role === "admin"
    const [visible, setVisible] = React.useState(false);
    const [visibleSelectDepartmentModal, setVisibleSelectDepartmentModal] = React.useState(false);
    const [removing, setRemoving] = React.useState(null);
    const [assignedDepartment, setAssignedDepartment] = useState([]);
    const [removingUsers, setRemovingUsers] = useState([]);
    const [removeDepartmentMutation, { error: errorRemove, data: dataRemove, loading: loadingRemove }] = useMutation(REMOVE_DEPARTMENT);

    useEffect(() => {
        if (data) {
            const tmp = []
            data?.map((item) => {
                tmp.push({
                    label: t(getDepartmentLabel(item?.department)),
                    value: item?.department
                })
            })
            setAssignedDepartment(tmp)
        }
    }, [data])

    let loadingUnassign = false
    function removeDepartment() {
        const tmpRemovingUser = []
        removingUsers?.map((item) => tmpRemovingUser.push(item?.user?.id))
        removeDepartmentMutation({
            variables: {
                id,
                department: removing?.value,
                removeUsers: tmpRemovingUser
            }
        })
        setVisible(false)
    }

    function getAssignedUserByDepartment(department) {
        const tmp = []
        assignedUserData?.map(item => {
            if (item?.user?.department === department) {
                tmp.push(item)
            }
        })
        setRemovingUsers(tmp)
    }

    function getDisplayName(user) {
        let displayName = user?.username;
        if (currentLang === 'kh') {
            displayName = user?.fullNameKhmer ? user?.fullNameKhmer : user?.fullName ? user?.fullName : user?.username;
        } else {
            displayName = user?.fullName ? user?.fullName : user?.fullNameKhmer ? user?.fullNameKhmer : user?.username;
        }
        return displayName;
    }

    function removeTheRemovingUser(user) {
        const tmp = []
        removingUsers?.map((item) => {
            if (user?.id !== item?.user?.id) {
                tmp.push(item)
            }
        })
        setRemovingUsers(tmp)
    }

    useEffect(() => {
        if (dataRemove) {
            callBack()
        }
    }, [dataRemove])

    function getRemoveOffice() {
        let allDpOffice = []
        c.departments.map((dp) => { if (dp.value === removing?.value) { allDpOffice = dp.offices } })
        let tmpRemoveOffice = []
        officeData.map((od) => {
            allDpOffice?.map(adpo => {
                if (adpo?.value === od?.office) {
                    tmpRemoveOffice.push(adpo)
                }
            })
        })
        return tmpRemoveOffice
    }

    return (
        <>
            <Flex alignItems="center" mt="2">
                <Text
                    fontWeight="bold"
                    minW={leftLabelWidth}
                    w={leftLabelWidth}
                    marginRight="4"
                >
                    {t('Department')}
                </Text>
                {assignedDepartment?.length > 0 ? <Flex marginRight="2">
                    <TokenGroup
                        className={canAssign ? "" : "can-not-assign-department"}
                        onDismiss={({ detail: { itemIndex } }) => {
                            setRemoving(assignedDepartment[itemIndex])
                            getAssignedUserByDepartment(assignedDepartment[itemIndex]?.value)
                            setVisible(true)
                        }}
                        items={assignedDepartment}
                    />
                </Flex> : <Text className="show-only-printing ">N/A</Text>
                }
                <Flex marginTop="8px">
                    {canAssign ?
                        <Button className="hidden-print" onClick={() => setVisibleSelectDepartmentModal(true)} iconName="add-plus" variant="primary" /> :
                        assignedDepartment?.length <= 0 && <Text className="hidden-print">N/A</Text>
                    }
                </Flex>
            </Flex>

            <Modal
                onDismiss={() => {
                    if (!loadingUnassign) {
                        setVisible(false)
                    }
                }}
                visible={visible}
                footer={
                    <Box float="right">
                        <SpaceBetween direction="horizontal" size="xs">
                            <Button variant="link" loading={loadingUnassign} onClick={() => setVisible(false)}>{t("Cancel")}</Button>
                            <Button loading={loadingUnassign} variant="primary" onClick={() => removeDepartment()}>{t("Okay")}</Button>
                        </SpaceBetween>
                    </Box>
                }
                header={`${t("Unassign department")} ${removing?.label}`}
            >
                {(getRemoveOffice()?.length > 0) &&
                    <Flex direction="column" mb="4">
                        <ul>
                            <Text fontWeight={600}>{t("Offices below will be unassign from this proposal")}</Text>
                            {getRemoveOffice()?.map((rmOffice, index) => {
                                return (
                                    <li key={`rm-of-${index}`} style={{ marginLeft: 20 }}>
                                        {currentLang === "en" ? rmOffice?.label : rmOffice.labelKh}
                                    </li>
                                )
                            })}
                        </ul>
                    </Flex>}


                <Flex fontWeight={600}>
                    {t("User below will be unassign from this proposal")}
                </Flex>
                <Flex mt="2">
                    {removingUsers?.length <= 0 && <>N/A</>}
                    {
                        removingUsers?.map((item, index) => {
                            return (
                                <Flex key={`r-u-${index}`} direction="column" justifyContent="center" alignItems="center" mr="1">
                                    <WrapItem className="avatarWraper">
                                        {(currentUser?.role === 'admin' ||
                                            (currentUser?.canAssignUserToCompanyProposal === true &&
                                                currentUser.id === item.createdBy)) && (
                                                <FontAwesomeIcon
                                                    onClick={() => removeTheRemovingUser(item?.user)}
                                                    className="remove"
                                                    icon={faMinusSquare}
                                                    style={{
                                                        fontSize: 18,
                                                        display: 'none',
                                                        position: 'absolute',
                                                        zIndex: '100',
                                                        marginLeft: 32,
                                                        color: 'red',
                                                        backgroundColor: 'white',
                                                        padding: 2,
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            )}
                                        <Avatar
                                            name={getDisplayName(item?.user)}
                                            src={item?.user?.avatar?.icon ? c.baseFilePath + item?.user?.avatar?.icon : null}
                                        />
                                    </WrapItem>
                                    <Text textAlign="center">{getDisplayName(item.user)}</Text>
                                </Flex>
                            )
                        })
                    }
                </Flex>
            </Modal>

            {visibleSelectDepartmentModal && <SelectDepartmentModal
                selectedItems={assignedDepartment}
                onClose={() => setVisibleSelectDepartmentModal(false)}
                callBack={e => callBack()}
                id={id}
            />}
        </>
    );
}
